/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WalletType = {
    WALLET_CONNECT: 'WALLET_CONNECT',
    MAGIC: 'MAGIC',
    SIGNED_URL: 'SIGNED_URL',
    SOLANA: 'SOLANA',
    THIRDWEB: 'THIRDWEB',
    VIRTUAL: 'VIRTUAL'
} as const;
export type WalletType = typeof WalletType[keyof typeof WalletType];


export function instanceOfWalletType(value: any): boolean {
    for (const key in WalletType) {
        if (Object.prototype.hasOwnProperty.call(WalletType, key)) {
            if (WalletType[key as keyof typeof WalletType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WalletTypeFromJSON(json: any): WalletType {
    return WalletTypeFromJSONTyped(json, false);
}

export function WalletTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WalletType {
    return json as WalletType;
}

export function WalletTypeToJSON(value?: WalletType | null): any {
    return value as any;
}

export function WalletTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): WalletType {
    return value as WalletType;
}

